/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { SubscriptionIndexPathParams, SubscriptionIndexResponse } from '../types/SubscriptionIndex'

/**
 * GET /:organisation/subscription
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::index
 */
export async function subscriptionIndex(
	organisation: SubscriptionIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionIndexResponse>> {
	return axiosInstance.get(`/${organisation}/subscription`, config)
}
